import React, { useState, useEffect, useRef, useCallback } from 'react';

const HookDemo = () => {
  console.log('🔄 Render del componente'); // Esto se ejecuta cada vez que React renderiza el componente

  // NUEVO: estados para gate de acceso
const [isAuthed, setIsAuthed] = useState(false);
const [showAuth, setShowAuth] = useState(false);
const [authPassword, setAuthPassword] = useState('');
const [authError, setAuthError] = useState('');
 // -- login

  const [count, setCount] = useState(0);
  const [text, setText] = useState('');
  const inputRef = useRef(null);

/*   useEffect(() => {
    console.log("versi esta ligeado");
    const tk = localStorage.getItem('token');
    if (tk && tk.length > 0) {
      setIsAuthed(true); // ya logeado, no pedimos password
    }
  }, []); */

  // Se ejecuta una vez cuando el componente se monta
  useEffect(() => {
    console.log(' useEffect con []: Componente montado');

    return () => {
      console.log('Limpieza: Componente desmontado');
    };
  }, []);

  // Se ejecuta cada vez que cambia `count`
  useEffect(() => {
    console.log(`📦 useEffect: El valor de count cambió a ${count}`);
  }, [count]);

  const handleClick = useCallback(() => {
    console.log('👆 Botón presionado');
    setCount(prev => prev + 1);
  }, []);

  const handleInput = (e) => {
    setText(e.target.value);
    console.log('📝 Texto ingresado:', e.target.value);
  };

  const focusInput = () => {
    inputRef.current.focus();
    console.log('🔍 Input enfocado por referencia');
  };

  return (
    <div style={{ padding: '1rem', fontFamily: 'Arial' }}>
      <h2>Ejemplo de Hooks</h2>
      <p>Contador: {count}</p>
      <button onClick={handleClick}>Incrementar</button>

      <br /><br />

      <input
        ref={inputRef}
        type="text"
        value={text}
        onChange={handleInput}
        placeholder="Escribe algo"
      />
      <button onClick={focusInput}>Enfocar input</button>
    </div>
  );
};

export default HookDemo;
